export enum AssessmentQuestionType {
  Objetiva,
  Discursiva,
}
